//css
import "./ChooseOrganization.css";
//components
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import Loader from "../common/Loader";

//images
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { fetchOrganizations } from "../../service/organizationService";
import { useNavigate } from "react-router-dom";

function ChooseOrganization(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("0");
  const { t } = useTranslation();

  useEffect(() => {
    fetchOrganizations().then((response) => {
      setOrganizations(response.data.organisations);
    });
  }, []);

  async function chooseOrganization(e) {
    e.preventDefault();
    if (selectedOrg !== "0") {
      localStorage.setItem("selectedOrgId", selectedOrg);
      window.dispatchEvent(new Event("storage"));
      navigate("/");
    }
  }

  return (
    <Container className="org_window">
      <Row className="org-head org-form">
        <div className="org-heading">Sprayzapp</div>
      </Row>
      <Row className="org-form">
        <Row style={{ paddingTop: "10px" }}>
          <Form.Label className="org-headline">{t("orgList.label")}</Form.Label>
          <InputGroup className="mb-3">
            <Form.Select
              value={selectedOrg}
              style={{ width: "max-content" }}
              onChange={(e) => {
                setLoading(true);
                setSelectedOrg(e.target.value);
                setLoading(false);
              }}
            >
              <option value={0}>Select</option>
              {(organizations || []).map((obj) => {
                return (
                  <option key={obj.name} value={obj.orgId}>
                    {obj.name}
                  </option>
                );
              })}
            </Form.Select>
          </InputGroup>
        </Row>

        <Row style={{ margin: "auto" }}>
          <Button
            variant="primary"
            className="org-btn"
            size="lg"
            active
            onClick={chooseOrganization}
            disabled={selectedOrg === "0"}
          >
            {loading ? (
              <Loader
                loading={loading}
                loader={"loader  loader-org"}
                loaderColor={"#ffffff"}
                size={4}
              />
            ) : (
              <div className="org-btn-label">{t("chooseOrg.continue.btn")}</div>
            )}
          </Button>{" "}
        </Row>
      </Row>
    </Container>
  );
}

export default ChooseOrganization;
